import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";

const EditAddForm = ({
  onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
  getBranchData,
}) => {
  console.log('rowData', rowData)
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    branchName: Yup.string().required("Branch Name is required."),
    
    branchCode: Yup.string().required("Branch Code is required."),
  });

  const formik = useFormik({
    initialValues: {
      branchName: rowData?.name || "",
      district: rowData?.district || "",
      region: rowData?.region || "",
      area: rowData?.area || "",
      branchCode: rowData?.branchCode || "",
    },
    validationSchema,
    onSubmit: async (data) => {
      setLoading(true);
  
      try {
        let response;
        if (editable) {
          const updatedData = {
            branchId: rowData.id,
            newBranchName: data.branchName, 
            district: data.district,
            region: data.region,
            area: data.area,
            branchCode: data.branchCode,
          };
          response = await axiosApi.put("/Portal/branches/edit", updatedData);
          toast.success("Updated successfully!");
        } else {
          response = await axiosApi.post("/Portal/branches/add", data);
          toast.success("Added successfully!");
        }
        setRes(response.data);
        getBranchData();
        setShowDialog(false);
      } catch (error) {
        toast.error(
          error.response?.data?.message || "An error occurred. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
  });
  

  return (
    <div className="main-form">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Branch Name <span className="text-danger"> *</span>
            </label>
            <InputText
              id="branchName"
              name="branchName"
              maxLength={"30"}
              value={formik.values.branchName}
              placeholder="Enter Branch Name"
              onChange={formik.handleChange}
            />
            {formik.touched.branchName && formik.errors.branchName && (
              <small className="p-error">{formik.errors.branchName}</small>
            )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="district">
            District 
            </label>
            <InputText
              id="district"
              name="district"
              maxLength={"30"}
              value={formik.values.district}
              placeholder="Enter District"
              onChange={formik.handleChange}
            />
           
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
            Region 
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              id="region"
              name="region"
              maxLength={"30"}
              value={formik.values.region}
              placeholder="Enter Region"
              onChange={formik.handleChange}
            />
          
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
            Area 
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              id="area"
              name="area"
              maxLength={"30"}
              value={formik.values.area}
              placeholder="Enter Area "
              onChange={formik.handleChange}
            />
          
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
            Branch Code <span className="text-danger"> *</span>
            </label>
            <InputText
              //   keyfilter={/^[a-zA-Z\s]*$/}
              id="branchCode"
              name="branchCode"
              maxLength={"10"}
              value={formik.values.branchCode}
              placeholder="Enter Branch Code "
              onChange={formik.handleChange}
            />
            {formik.touched.branchCode && formik.errors.branchCode && (
              <small className="p-error">{formik.errors.branchCode}</small>
            )}
          </div>
        </div>

        <div className="form-buttons mt-4">
          <ActionButtons
            loading={loading}
            onCancel={onHide}
            onSave={formik.handleSubmit}
            saveLabel={editable ? "Update Changes" : "Save Changes"}
            showSave={true}
            cancelLabel="Cancel"
          />
        </div>
      </form>
    </div>
  );
};

export default EditAddForm;
